import React, { useState, useEffect } from 'react';
import { Link, useLocation } from '@reach/router';
import { Box } from '@material-ui/core';
import AuthMenu from '../../Auth/components/Menu';
import CommonLanguageSwitch from '../../Common/components/LanguageSwitch';
import { ReactComponent as Logo } from './wildling-repair-rebels-logo.svg';
import classes from './Navbar.module.css';
import CartButton from 'components/CartButton';

const SCROLL_THRESHOLD = 10;

export default function Navbar() {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    function onScroll() {
      setScrolled(window.scrollY > SCROLL_THRESHOLD);
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  function handleScroll() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  return (
    <nav className={`navbar navbar-expand-sm ${classes.nav} ${scrolled || location.pathname === '/' ? classes.navScrolled : ''}`}>
      <div className="container">
        <div className={classes.container}>
          <Link to="/" onClick={handleScroll} className={classes.logoLink}>
            <Logo title="Repair Rebels" className={classes.logo} />
          </Link>
          <div className={classes.rightGroup}>
            <Box>
              <CommonLanguageSwitch />
            </Box>
            <Box>
              <AuthMenu />
            </Box>
            <CartButton location={location} />
          </div>
        </div>
      </div>
    </nav>
  );
}
